import React from 'react';
import ReactDOM from 'react-dom';
import ResourcesSearchPage from '../jsx/ResourcesSearchPage';

export default function _resourcesSearchPage() {
    /**
     * Component item selector
     * @const {string}
     */
    const SELECT_WRAPPER_SELECTOR = '.js-resources-search-component';

    /**
     * REACT item selector
     * @const {string}
     */
    const REACT_WRAPPER_SELECTOR = '#react-resources-search-component-root';

    class ResourcesSearchPageScripts {
        constructor() {
            const reactAppWrapper = document.querySelector(
                REACT_WRAPPER_SELECTOR
            );

            const reactAppSuggestionsUrl = reactAppWrapper.getAttribute(
                'data-suggestions-url'
            );

            const reactAppSearchUrl =
                reactAppWrapper.getAttribute('data-search-url');

            const reactAppLookupUrl =
                reactAppWrapper.getAttribute('data-lookup-url');

            const reactAppFallbackImage = reactAppWrapper.getAttribute(
                'data-result-fallback-image-id'
            );

            const reactElement = React.createElement(
                ResourcesSearchPage,
                {
                    suggestionsUrl: reactAppSuggestionsUrl,
                    searchUrl: reactAppSearchUrl,
                    lookupUrl: reactAppLookupUrl,
                    resultFallbackImageId: reactAppFallbackImage,
                },
                null
            );

            // Add the REACT component to the page
            if (reactAppWrapper !== null) {
                ReactDOM.render(reactElement, reactAppWrapper);
            }

            // Any other JavaScript can go here as per standard.
        }
    }

    const components = document.querySelectorAll(SELECT_WRAPPER_SELECTOR);
    components.forEach((component) => {
        const DOMItem = component;

        // Attach the instance to the DOM once
        if (!DOMItem.component) {
            DOMItem.component = new ResourcesSearchPageScripts();
        }
    });
}

_resourcesSearchPage();
